import { Close } from '@mui/icons-material';
import { Dialog, Box, IconButton } from '@mui/material';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import { FullScreenNotificationProps } from 'src/features/inAppNotifications/presentation/components/FullScreenNotification/FullScreenNotification.types';
import NotificationLink from 'src/features/inAppNotifications/presentation/components/NotificationLink';

const FullScreenNotification: React.FC<FullScreenNotificationProps> = ({
  open,
  onClose,
  notification,
  onContentClick: handleContentClick,
}) => {
  const { isMobile } = useAppUI();

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiBackdrop-root': {
          backdropFilter: 'blur(5px)',
        },
      }}
      PaperProps={{
        sx: {
          padding: 0,
          alignItems: 'center',
          width: '100%',
          margin: 2,
          boxShadow: 'none',
          background: 'transparent',
        },
      }}
    >
      {isMobile ? (
        <IconButton
          aria-label="close"
          size="large"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
          }}
        >
          <Close />
        </IconButton>
      ) : null}

      <NotificationLink
        url={notification.action_data.url}
        onClick={handleContentClick}
      >
        <Box
          component="img"
          src={notification.action_content}
          alt={notification.title || 'Notification Image'}
          sx={{
            width: '100%',
            objectFit: 'contain',
            height: 'auto',
            borderRadius: (theme) => `${theme.shape.borderRadius * 2}px`,
            maxHeight: '895px',
          }}
        />
      </NotificationLink>
    </Dialog>
  );
};

export default FullScreenNotification;
